export const CARD_APP_STORE_URL = 'https://apps.apple.com/us/app/robinhood-banking/id6462308655';
export const CARD_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.robinhood.money';
